import { render, staticRenderFns } from "./BaseDialog.vue?vue&type=template&id=282e1a12&"
import script from "./BaseDialog.vue?vue&type=script&lang=js&"
export * from "./BaseDialog.vue?vue&type=script&lang=js&"
import style0 from "./BaseDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports